import React from "react";
// import axios from "axios";
import Slider from "react-slick";
import "./mainslider.css";
class mainSlider extends React.Component {
  /*  constructor(props) {
    super(props);
    this.state = {
      slider: [],
    };
  }
  componentDidMount() {
    axios
      .get(
        encodeURI(
          process.env.REACT_APP_API_URL +
            "api/resource/Homepage Section/Home Slider"
        ),
        {
          headers: {
            "content-type": "application/json",
          },
        }
      )
      .then((response) => {
        this.setState({ slider: response.data.data.section_cards });
        //console.log(response.data.data.section_cards)
        //alert()
      })
      .catch((response) => {
        console.log(response + " api/resource/Homepage Section/Homeslider");
        //alert("no")
      });
  } */
  render() {
    var settings = {
      slidesToShow: 1,
      fade: true,
      speed: 500,
      slidesToScroll: 1,
      fade: true,
      loop: true,
      dots: false,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 4000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 1,
            dots: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
          },
        },
      ],
    };

    return (
      <div className="container-fluid mb-5">
        <div className="row">
          <div className="home-slider hero-slider section">
            <div className="hero-slider-active-2 nav-style-1 nav-style-1-green">
              <Slider {...settings}>
                <div className="slider-item">
                  <div className="slider-head-center">
                    <h3 className="subtitile-font"> Creative Design <br/> Modern & Exclusive Furniture</h3>
                    <a href="shop.html" style={{"width":"135px","marginLeft":"221px","borderRadius": '30px',"border": '1px solid black'}} class="btn">SHOP NOW</a>
                  </div>
                  <img
                    src="assets/images/hero/hero-1.jpg"
                    className="home-slider-imge bg-image"
                    width="100%"
                    alt="img"
                  />
                </div>
                <div className="slider-item">
                  <div className="slider-head-center">
                    <h3 className="subtitile-font"> Creative Design <br/> Modern & Exclusive Furniture</h3>
                    <a  href="shop.html" style={{"width":"135px","marginLeft":"221px","borderRadius": '30px',"border": '1px solid black'}} class="btn">SHOP NOW</a>
                  </div>
                  <img
                    src="assets/images/hero/hero-2.jpg"
                    className="home-slider-imge"
                    width="100%"
                    alt="img"
                  />
                </div>
              {/*   <div className="slider-item">
                  <div className="slider-head-center">
                    <h3 className="subtitile-font"> Creative Design <br/> Modern & Exclusive Furniture</h3>
                  </div>
                  <img
                    src="assets/images/hero/hero-1.jpg"
                    className="home-slider-imge"
                    width="100%"
                    alt="img"
                  />
                </div> */}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default mainSlider;
